import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/utils/constants';
import { BehaviorSubject } from 'rxjs';
import { SaleAllParameters } from 'src/app/models/SaleAllParameters';
import { SaleParameters } from 'src/app/models/SaleParameters';
import { AppConfigServiceService } from '../app-config-service.service';
import { HelpersService } from '../shared/helpers.service';

@Injectable({
  providedIn: 'root'
})
export class SaleService {

  public saleParametersSource = new BehaviorSubject<SaleAllParameters>(JSON.parse(localStorage.getItem('saleParameters')));
  public currentSaleParameters = this.saleParametersSource.asObservable();

  public saleTypeSource = new BehaviorSubject<string>(localStorage.getItem('saleType'));
  public currentSaleType = this.saleTypeSource.asObservable();

  public saleFilterSource = new BehaviorSubject<string>(localStorage.getItem('saleFilter'));
  public currentSaleFilter = this.saleFilterSource.asObservable();

  public curHostname;
  constructor(private http: HttpClient, private MY_CONSTANTS: Constants,
    private appConfigService: AppConfigServiceService, private helpersService: HelpersService) {
      this.helpersService.currentHostname.subscribe( data => {
        this.curHostname = data;
      });
    }

  changeSaleParameters(parameters: SaleAllParameters) {
    localStorage.setItem('saleParameters', JSON.stringify(parameters));
    this.saleParametersSource.next(parameters);
  }

  public get currentSaleParametersValue(): SaleAllParameters {
    return this.saleParametersSource.value;
}

  changeSaleType(saleType) {
    localStorage.setItem('saleType', (saleType));
    this.saleTypeSource.next(saleType);
  }

  public get currentSaleTypeValue(): string {
    return this.saleTypeSource.value;
  }

  changeSaleFilter(saleFilter) {
    localStorage.setItem('saleFilter', (saleFilter));
    this.saleFilterSource.next(saleFilter);
  }

  public get currentSaleFilterValue(): string {
    return this.saleFilterSource.value;
  }
saleNoParams(sessionUser, dateFrom, dateTo, showPartners, showEURValues,/* showTaxValues,*/ saleType) {
  let params = new HttpParams();

  /*if(sessionUser) {
    params = params.append('sessionUser', sessionUser);
  }*/
  params = params.append('sessionUser', sessionUser);
  if(dateFrom) {
    params = params.append('dateFrom', dateFrom);
  }

  if(dateTo) {
    params = params.append('dateTo', dateTo);
  }

  params = params.append('saleType', saleType);
  if(showPartners) {
    params = params.append('showPartners', showPartners);
  }

  if(showEURValues) {
    params = params.append('showEURValues', showEURValues);
  }

 /* if(showTaxValues) {
    params = params.append('showTaxValues', showTaxValues);
  }*/
  //return this.http.post<any>(/*this.MY_CONSTANTS.API + */'http://172.200.3.77:8080/Skulptur.Api/rest/web/sale', params);
  return this.http.post<any>(/*this.MY_CONSTANTS.API + */this.curHostname + this.appConfigService.apiSale + 'sale', params);
}

  sale(sessionUser, dateFrom, dateTo, REPAPNL1, reportId, showPartners, showEURValues , /*showTaxValues,*/ workerWarehouseTypes,
    workerWarehouseCountries, order, sort, fetch, saleType, groupType, workerWarehouses) {
    let params = new HttpParams();

    /*if(sessionUser) {
      params = params.append('sessionUser', sessionUser);
    }*/
    params = params.append('sessionUser', sessionUser);
    if(dateFrom) {
      params = params.append('dateFrom', dateFrom);
    }

    if(dateTo) {
      params = params.append('dateTo', dateTo);
    }

    params = params.append('saleType', saleType);
    if(showPartners) {
      params = params.append('showPartners', showPartners);
    }

    if(showEURValues) {
      params = params.append('showEURValues', showEURValues);
    }

  /*  if(showTaxValues) {
      params = params.append('showTaxValues', showTaxValues);
    }*/

    if(REPAPNL1) {
      params = params.append('REPAPNL1', REPAPNL1);
    }

    if(reportId) {
      params = params.append('reportId', reportId);
    }

    if(workerWarehouseTypes) {
      params = params.append('workerWarehouseTypes', JSON.stringify(workerWarehouseTypes));
    }

    if(workerWarehouseCountries) {
      params = params.append('workerWarehouseCountries', JSON.stringify(workerWarehouseCountries));
    }

    if(order) {
      params = params.append('order', order);
    }

    if(sort) {
      params = params.append('sort', sort);
    }

    if(fetch) {
      params = params.append('fetch', fetch);
    }

    if(groupType) {
      params = params.append('groupType', groupType);
    }

    //workerWarehouses != 'null' je zato, ker sem v sale.filter naredil da lahko izbere pod Skladisca - Vsa skladišča in ta Vsa skladišča imajo id='null'.
    if(workerWarehouses && workerWarehouses != 'vsa') {
      params = params.append('warehouseId', workerWarehouses);
    }
    //return this.http.post<any>(/*this.MY_CONSTANTS.API + */'http://172.200.3.77:8080/Skulptur.Api/rest/web/sale', params);
    return this.http.post<any>(/*this.MY_CONSTANTS.API + */this.curHostname + this.appConfigService.apiSale + 'sale', params);
  }

  reports(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>(this.curHostname + this.appConfigService.apiSale + 'reports', params);
  }

  workerWarehouseTypes(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>(this.curHostname + this.appConfigService.apiSale + 'workerWarehouseTypes ', params);
  }

  workerCountries(sessionUser){
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>(this.curHostname + this.appConfigService.apiSale + 'workerCountries  ', params);
  }

  getAnalytics(sessionUser, helpdesk, project, statuses, cooperations,
    processes, dateFrom, dateTo) {
      let params = new HttpParams();
      params = params.append('sessionUser', sessionUser);

        params = params.append('helpdesk', helpdesk);


        params = params.append('project', project);

      if(statuses && statuses.length > 0) {
        console.log(statuses);
        params = params.append('statuses', JSON.stringify(statuses));
      }
      if(cooperations && cooperations.length > 0) {
        console.log(cooperations);
        params = params.append('cooperations', JSON.stringify(cooperations));
      }
      if(processes && processes.length > 0) {
        console.log(processes);
        params = params.append('processes', JSON.stringify(processes));
      }
      if(dateFrom) {
        params = params.append('dateFrom', dateFrom);
      }
      if(dateTo) {
        params = params.append('dateTo', dateTo);
      }
      return this.http.post<any>(this.curHostname + this.appConfigService.apiSale + 'getAnalytics', params);
  }

  groupTypes(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', sessionUser);
    return this.http.post<any>(this.curHostname + this.appConfigService.apiSale + 'groupTypes', params);
  }

  workerWarehouse(sessionUser) {
    let params = new HttpParams();
    params = params.append('sessionUser', 'TOMAZ');
    return this.http.post<any>(this.curHostname + this.appConfigService.apiSale + 'workerWarehouses', params);
  }
}
